import * as Sentry from '@sentry/browser';
import queryString from 'query-string';

import EnvConfig from '../../envConfig';
import ConverterApp from './app';
import devConfig from './devConfig';
import {
  disablePricePlaceholderStyles,
  enablePricePlaceholderStyles,
} from './pricePlaseholder';

const ENV = EnvConfig.ENV;
if (ENV !== 'development') {
  const SENTRY_DSN = EnvConfig.SENTRY_DSN;
  const SENTRY_ENV = EnvConfig.SENTRY_ENV;
  const VERSION = EnvConfig.VERSION;
  Sentry.init({ dsn: SENTRY_DSN, environment: SENTRY_ENV, release: VERSION });
}

const appId = EnvConfig.ECWID_APP_ID;
const Ecwid = window.Ecwid;
const fakeConfigFlag = 'simcase-local-config';
const fakeConfigLocalStorageKey = 'simcaseWLCCFakeLocalConfig';

const INTERVAL = 1000;
let simcaseInterval = null;

const resolveConfig = () => {
  const parsedQueryString = queryString.parse(location.search);
  const isFakeConfigNecessary = parsedQueryString[fakeConfigFlag];
  const fakeConfig = window.localStorage.getItem(fakeConfigLocalStorageKey);
  if (isFakeConfigNecessary && fakeConfig) {
    return JSON.parse(fakeConfig);
  }

  const isDevEnv = process.env.ENV === 'devlopment';
  if (isDevEnv) {
    return devConfig;
  }

  return JSON.parse(Ecwid.getAppPublicConfig(appId)).config;
};

Ecwid.OnAPILoaded.add(async () => {
  try {
    const storeId = Ecwid.getOwnerId();
    const publicToken = Ecwid.getAppPublicToken(appId);
    const appConfig = resolveConfig();

    const isNeededConverterDisabling = appConfig.currencies.length === 0;
    if (isNeededConverterDisabling) {
      disablePricePlaceholderStyles();
      return;
    }

    await ConverterApp.prepare(storeId, publicToken, appConfig);
  } catch (exception) {
    disablePricePlaceholderStyles();
    console.error(exception); // eslint-disable-line no-console
    Sentry.captureException(exception);
    ConverterApp.deactivate();
    return;
  }

  Ecwid.OnPageLoad.add(() => {
    enablePricePlaceholderStyles();
  });

  Ecwid.OnPageLoaded.add((page) => {
    try {
      ConverterApp.activate(page);
      disablePricePlaceholderStyles();
    } catch (exception) {
      disablePricePlaceholderStyles();
      console.error(exception); // eslint-disable-line no-console
      Sentry.captureException(exception);
      ConverterApp.deactivate(page);
    }

    if (simcaseInterval) {
      clearInterval(simcaseInterval);
    }

    simcaseInterval = setInterval(() => {
      try {
        ConverterApp.activate(page);
      } catch (exception) {
        Sentry.captureException(exception);
        clearInterval(simcaseInterval);
        ConverterApp.deactivate(page);
      }
    }, INTERVAL);
  });
});
